import { render, staticRenderFns } from "./Horizontal.vue?vue&type=template&id=71a1aaa7"
import script from "./Horizontal.vue?vue&type=script&lang=js"
export * from "./Horizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports